import React, { useEffect, useState } from "react";
// material
import {
  Card,
  CardHeader,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Divider,
  Typography,
  Paper,
  InputBase,
  IconButton,
  Input
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
//
import {
  createComment,
  getComments,
  getCommentsByUserId
} from "../../core/service/comments.service";
// ----------------------------------------------------------------------

export default function Comment({ sx, report, user_id }) {
  const [comment, setComment] = useState([{}]);
  const [listComments, setListComments] = useState({ comments: [] });
  const { comments } = listComments;

  const createComments = async (data) => {
    await createComment(data).then(() => {
      getCommentsList();
    });
  };

  const getCommentsList = async (report) => {
    if (report) {
      const { report_id } = report;
      if (report_id) {
        const data = await getComments(report_id);
        setListComments(data);
      }
    } else return;
  };

  const getCommentsListByUser = async (user_id) => {
    if (user_id) {
      const data = await getCommentsByUserId(user_id);
      setListComments(data);
    } else return;
  };

  useEffect(() => {
    if (report) {
      getCommentsList(report);
    } else {
      getCommentsListByUser(user_id);
    }
  }, []);

  return (
    <Card sx={{ ...sx }}>
      <CardHeader title="Comment" />
      {comments?.map((users, i, row) => (
        <List key={i}>
          <ListItem alignItems="flex-start">
            <ListItemAvatar key={i}>
              <Avatar src="/member/static/images/avatars/avatar_default.jpg" />
            </ListItemAvatar>
            <ListItemText
              primary={
                `${users.title_name_en} ${users.name_en} ${users.middle_name_en}` ||
                ""
              }
              secondary={
                <>
                  <Typography
                    sx={{ display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.primary"
                  >
                    {users.comment}
                  </Typography>
                </>
              }
            />
          </ListItem>
          {i + 1 === row.length ? null : (
            <Divider variant="inset" component="li" />
          )}
        </List>
      ))}
      <Divider />
      <Paper
        component="form"
        sx={{ p: "2px 4px", display: "flex", alignItems: "center" }}
      >
        <InputBase
          onChange={(e) => {
            setComment(e.target.value);
          }}
          sx={{ ml: 1, flex: 1 }}
          placeholder="Text"
        />

        <label htmlFor="icon-button-file">
          <Input
              inputProps={{
                            accept:
                              "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
                          }}
            id="icon-button-file"
            type="file"
            sx={{ display: "none" }}
          />
          <IconButton aria-label="upload picture" component="span">
            <InsertPhotoIcon />
          </IconButton>
        </label>

        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
        <IconButton
          onClick={() => {
            let data = new FormData();
            data.append("user_id", report.user_id);
            data.append("progress_report_form_id", report.report_id);
            data.append("comment", comment);
            createComments(data);
          }}
          color="info"
          sx={{ p: "10px" }}
        >
          <SendIcon />
        </IconButton>
      </Paper>
    </Card>
  );
}
